import React, { ErrorInfo, ReactNode } from "react";

export default class ErrorBoundary<P extends { children: ReactNode}> extends React.Component<P, { hasError: boolean }> {
    constructor(props: P) {
        super(props);
        this.state = { hasError: false };
    }
    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        this.setState({ hasError: true });
        // eslint-disable-next-line no-console
        console.error(error, errorInfo);
    }

    override render() {
        if(this.state.hasError) {
            return React.createElement('h1', {}, 'Something went wrong.');
        }
        return this.props.children;
    }
}
